<div class="cvGroupAssignToolOverlay" *ngIf="awardToolVisible"></div>
<div class="cvGroupAssignToolPopupContainer modal-dialog modal-xl modal-dialog-centered" style="z-index: 10000;" *ngIf="awardToolVisible">
  <div class="modal-content">
      <div class="FlexRowNoWrap topContainer">
          <div class="FlexRowNoWrap nameHolder">
              <div class="FlexRowNoWrap FlexAlignVertical nameText txtOverflow">
                  <div runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Assign_Recipients">Assign Recipients</div>
              </div>
          </div>
          <div class="closeImgHolder">
              <div class="closeImg" (click)="closePopup()"></div>
          </div>
      </div>
      <div class="midContainer FlexRowNoWrap">
          <div class="leftBox assignToolLeftBoxScroll">
              <div class="drillDown FlexRowNoWrap">
                  <div class="iconPlaceholder"></div>
                  <div class="text" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Logins">Logins</div>
              </div>
          </div>
          <div class="midBox">
              <div class="FlexRowNoWrap searchContainer">
                  <div class="search-box live-search mx-4">
                      <input type="search" class="form-control form-control-lg" placeholder="Search" [(ngModel)]="filterText"
                         cvLocalizedPlaceholder langSection="Common" langKey="Search" (ngModelChange)="updateGridFilter()" />
                      <span class="clear-input" *ngIf="filterText?.length > 0" (click)="clearSearch()"></span>
                  </div>
              </div>
              <div class="FlexRowNoWrap headerContainer check-all-container">
                  <input type="checkbox" [(ngModel)]="isCheckedAll" (ngModelChange)="setAllChecked()" />
                  <div class="label" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="All">All</div>
              </div>
              <div class="agItemContainer">
                  <ag-grid-angular 
                    #giveAwardPopupGrid
                    class="ag-theme-balham font-size-14 h-100 w-100 overflow-auto"
                    [gridOptions]="gridOptions"
                    ></ag-grid-angular>
                    <cv-loader size="medium" [overlay]="true" *ngIf="isDataLoading"></cv-loader>
              </div>
              <div class="FlexRowNoWrap buttonContainer mt-2">
                  <button type="button" *ngIf="isItemsSelected()" class="btn btn-secondary add-button" [disabled]="!isItemsSelected()" (click)="addSelected()" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Add">Add</button>
              </div>
          </div>
          <div class="rightBox">
              <div class="objectivesAssignBox objectivesBoxScroll">
                  <div class="boxHeader"><span runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Awarding_To">Awarding to</span>:</div>
                  <div class="awarding-container">
                      <div class="typeHeader login-text" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Login_Semiplural">Login(s)</div>
                      <div class="objectiveHeaderItem" *ngIf="awardToList != null && awardToList.length < 1" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="No_Logins">No Logins</div>
                      <div *ngFor="let awardTo of awardToList; let index = index">
                          <div class="FlexRowNoWrap itemContainer">
                              <div class="objectiveItem txtOverflow">- {{awardTo.LoginName}}</div>
                              <select class="selectItem" [(ngModel)]="obj.applyAt" *ngIf="showall == false && obj.GroupLevel > 1">
                                  <ng-container *ngFor="let item of empgrouptypes">
                                    <option *ngIf="item.GroupLevel <= obj.GroupLevel" value="{{item.GroupLevel}}">{{item.GroupTypeName}}</option>
                                  </ng-container>
                              </select>
                              <div class="removeHolder FlexRowNoWrap">
                                  <div class="removeIcon FlexAlignVertical" (click)="removeItem(index, obj)"></div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="d-flex awardButtons">
          <div class="ml-auto mt-2">
              <button type="button" class="btn btn-text mr-2" (click)="closePopup()" runat="server" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
              <button type="button" class="btn btn-primary" [disabled]="awardToList == null || awardToList.length < 1 || giveInProgress" (click)="giveAwards()" runat="server" cvLocalizedText langSection="Rules_Engine" langKey="Award">Award</button>
          </div>
      </div>
  </div>
</div>
